import jump from 'jump.js';

export default {
  init() {

    /**
     * Slide in Featured Article
     */
    $('.featured-article').addClass('featured-article--ready');

    /**
     * Scroll to content
     */
    $('.scroll').on('click', function(){
      jump('.what-we-do', {
        a11y: true,
      });
    });

    // JavaScript to be fired on the home page
  },

  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js